<template>
  <img v-if="src && !failed" :key="src" :src="src" :alt="name" @error="onError" />
  <span v-else class="product-initial" role="img" :aria-label="`${name || '产品'}，暂无图片`">{{ initial }}</span>
</template>

<script>
export default {
  name: 'ProductImage',
  props: { src: { type: String, default: '' }, name: { type: String, default: '' } },
  data: () => ({ failed: false }),
  computed: { initial() { return Array.from(this.name.trim())[0] || '产'; } },
  watch: { src() { this.failed = false; } },
  methods: {
    onError(event) {
      // 只处理当前地址的加载结果，旧图片的迟到事件不影响新图。
      if (event.currentTarget.getAttribute('src') === this.src) this.failed = true;
    },
  },
};
</script>

<style scoped>
.product-initial { display: grid; place-items: center; color: #2563eb; font-size: 1.6rem; font-weight: 700; }
</style>
